import { useState } from "react";
import { FolderOpen, Library } from "lucide-react";
import { api } from "@/lib/api";
import { FolderDialog } from "@/components/sources/FolderBrowser";
import { PillButton } from "@/components/sources/shared";

// Root level lists Plex libraries; ids are "s:<section>" for a library and "<section>|<parent>" for folders.
const load = (sections) => async (parent) => {
  if (!parent) return { folders: sections.map((s) => ({ id: `s:${s.key}`, title: s.title })), files: 0 };
  const [section, pid] = parent.startsWith("s:") ? [parent.slice(2), undefined] : parent.split("|");
  const { data } = await api.get("/plex/folders", { params: { section, parent: pid } });
  return { ...data, folders: data.folders.map((f) => ({ id: `${section}|${f.id}`, title: f.title })) };
};

const current = (st) => {
  const keys = st.section_keys;
  if (!keys) return "All libraries";
  return keys.map((k) => {
    const sec = st.sections.find((s) => s.key === k);
    const folders = st.folder_filters?.[k] || [];
    return folders.length ? folders.map((f) => `${sec?.title}/${f}`).join(", ") : sec?.title;
  }).join(" · ");
};

export const PlexChooseFolder = ({ st, busy, onChoose }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-zinc-200 p-4" data-testid="plex-choose-folder">
      <Library size={16} className="text-amber-700" />
      <div className="min-w-0 flex-1">
        <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-400">Importing from</p>
        <p className="truncate font-mono text-sm" data-testid="plex-current-folder">{current(st)}</p>
      </div>
      <PillButton variant="light" onClick={() => setOpen(true)} disabled={busy} testid="plex-choose-folder-button"><FolderOpen size={14} />Choose folder</PillButton>
      <FolderDialog open={open} onOpenChange={setOpen} testid="plex-choose-folder-dialog" rootLabel="Plex libraries" load={load(st.sections)}
        title="Choose what to import" description="Pick a library, or open it and pick one folder inside. Only those videos are imported."
        cta="Import only this" onPick={({ trail }) => onChoose({ section: trail[0].id.slice(2), folder: trail.slice(1).map((t) => t.title).join("/") })} />
    </div>
  );
};
